import { FC } from 'react';

import { Button, ButtonProps } from 'antd';

import TelegramIcon from 'assets/images/icons/telegram.svg?react';
import { BOT_URL } from 'features/Telegram';

interface ITelegramBotIconProps extends ButtonProps {}

export const TelegramBotIcon: FC<ITelegramBotIconProps> = ({ className, ...props }) => {
	return (
		<Button
			{...props}
			href={BOT_URL}
			target="_blank"
			type="text"
			shape="circle"
			size="small"
			icon={<TelegramIcon width={14} height={14} />}
			className={className}
		/>
	);
};
